export default __webpack_public_path__ + "static/media/icon_search.e23a528d.svg";